<template>
    <v-container class="py-7">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span class="page-title">Gráficos por Classe</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›" :items="breadcrumbItems"></v-breadcrumbs>
                    </div>
                    <div class="button-group" style="display: flex; align-items: center; gap: 12px; padding-right: 16px;">
                        <v-tooltip bottom>
                            <template #activator="{ on, attrs }">
                                <v-btn type="button" elevation="0" color="primary" outlined v-on="on" v-bind="attrs"
                                    @click="generateVotingPdf()" :disabled="generatingPdf" :loading="generatingPdf">
                                    <v-icon left v-if="!generatingPdf">mdi-file-pdf-box</v-icon>
                                    Gerar PDF
                                </v-btn>
                            </template>
                            <span>Gerar laudo das adesões em PDF</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <template #activator="{ on, attrs }">
                                <v-btn type="button" elevation="0" color="primary" outlined to="/adesao-plano" v-on="on" v-bind="attrs">
                                    <v-icon left>mdi-arrow-left</v-icon>
                                    Voltar
                                </v-btn>
                            </template>
                            <span>Voltar para a listagem de adesões ao plano</span>
                        </v-tooltip>
                    </div>
                </div>
            </v-col>
        </v-row>
        <br>

        <!-- <br> -->

        <!-- Filtros -->
        <!-- <v-row dense class="mt-2">
            <v-col cols="12" sm="4">
                <v-select
                    v-model="filters.status"
                    :items="statusOptions"
                    item-text="text"
                    item-value="value"
                    label="Status da adesão"
                    outlined
                    dense
                    hide-details
                    clearable
                    @change="loadCharts"
                />
            </v-col>
            <v-col cols="12" sm="4">
                <v-select
                    v-model="filters.process_type"
                    :items="processTypeOptions"
                    item-text="text"
                    item-value="value"
                    label="Tipo de usuário"
                    outlined
                    dense
                    hide-details
                    clearable
                    @change="loadCharts"
                />
            </v-col>
        </v-row> -->

        <!-- Loading -->
        <v-row v-if="loading" class="mt-6">
            <v-col cols="12" class="text-center">
                <v-progress-circular indeterminate color="primary" size="64" />
                <p class="mt-3 grey--text">Carregando dados dos gráficos...</p>
            </v-col>
        </v-row>

        <!-- Bloco 1 — Classe I - Trabalhista -->
        <v-row v-if="!loading" class="mt-4">
            <v-col cols="12">
                <v-card class="card-form-outlined">
                    <v-card-title class="card-group-title">
                        <v-icon left color="#7E55AB">mdi-briefcase-outline</v-icon>
                        Classe I — Trabalhista
                        <v-spacer />
                        <v-chip small color="#7E55AB" text-color="white">
                            {{ chartData.trabalhista.adherenceCount.toLocaleString('pt-BR') }} / {{ chartData.trabalhista.totalCount.toLocaleString('pt-BR') }} credores
                        </v-chip>
                        <v-chip
                            v-for="currency in currencyOptions"
                            :key="'trabalhista-chip-' + currency.key"
                            small
                            color="#7E55AB"
                            text-color="white"
                            class="ml-2"
                        >
                            {{ currency.symbol }} {{ formatCurrency(chartData.trabalhista.currencies[currency.key].adherenceAmount) }} / {{ currency.symbol }} {{ formatCurrency(chartData.trabalhista.currencies[currency.key].totalAmount) }}
                        </v-chip>
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12" md="3">
                                <div class="chart-subtitle">Proporção por Cabeça (quantidade de credores)</div>
                                <apexchart
                                    type="donut"
                                    height="350"
                                    :options="trabalhistaCountOptions"
                                    :series="trabalhistaCountSeries"
                                />
                            </v-col>
                            <v-col v-for="currency in currencyOptions" :key="'trabalhista-amount-' + currency.key" cols="12" md="3">
                                <div class="chart-subtitle">Proporção por Valor ({{ currency.label }})</div>
                                <apexchart
                                    type="donut"
                                    height="350"
                                    :options="buildAmountOptions('trabalhista', currency.key, ['#7E55AB', '#C4A4D8'])"
                                    :series="buildAmountSeries('trabalhista', currency.key)"
                                />
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <!-- Bloco 2 — Classe III - Quirografários -->
        <v-row v-if="!loading" class="mt-4">
            <v-col cols="12">
                <v-card class="card-form-outlined">
                    <v-card-title class="card-group-title">
                        <v-icon left color="#29B6F6">mdi-account-group-outline</v-icon>
                        Classe III — Quirografários
                        <v-spacer />
                        <v-chip small color="#1E88E5" text-color="white">
                            {{ chartData.quirografarios.adherenceCount.toLocaleString('pt-BR') }} / {{ chartData.quirografarios.totalCount.toLocaleString('pt-BR') }} credores
                        </v-chip>
                        <v-chip
                            v-for="currency in currencyOptions"
                            :key="'quirografarios-chip-' + currency.key"
                            small
                            color="#1E88E5"
                            text-color="white"
                            class="ml-2"
                        >
                            {{ currency.symbol }} {{ formatCurrency(chartData.quirografarios.currencies[currency.key].adherenceAmount) }} / {{ currency.symbol }} {{ formatCurrency(chartData.quirografarios.currencies[currency.key].totalAmount) }}
                        </v-chip>
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12" md="3">
                                <div class="chart-subtitle">Proporção por Cabeça (quantidade de credores)</div>
                                <apexchart
                                    type="donut"
                                    height="350"
                                    :options="quirografariosCountOptions"
                                    :series="quirografariosCountSeries"
                                />
                            </v-col>
                            <v-col v-for="currency in currencyOptions" :key="'quirografarios-amount-' + currency.key" cols="12" md="3">
                                <div class="chart-subtitle">Proporção por Valor ({{ currency.label }})</div>
                                <apexchart
                                    type="donut"
                                    height="350"
                                    :options="buildAmountOptions('quirografarios', currency.key, ['#1E88E5', '#90CAF9'])"
                                    :series="buildAmountSeries('quirografarios', currency.key)"
                                />
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <!-- Bloco 3 — Classe IV - ME/EPP -->
        <v-row v-if="!loading" class="mt-4">
            <v-col cols="12">
                <v-card class="card-form-outlined">
                    <v-card-title class="card-group-title">
                        <v-icon left color="#009688">mdi-store-outline</v-icon>
                        Classe IV — ME/EPP
                        <v-spacer />
                        <v-chip small color="#00796B" text-color="white">
                            {{ chartData.meEpp.adherenceCount.toLocaleString('pt-BR') }} / {{ chartData.meEpp.totalCount.toLocaleString('pt-BR') }} credores
                        </v-chip>
                        <v-chip
                            v-for="currency in currencyOptions"
                            :key="'meEpp-chip-' + currency.key"
                            small
                            color="#00796B"
                            text-color="white"
                            class="ml-2"
                        >
                            {{ currency.symbol }} {{ formatCurrency(chartData.meEpp.currencies[currency.key].adherenceAmount) }} / {{ currency.symbol }} {{ formatCurrency(chartData.meEpp.currencies[currency.key].totalAmount) }}
                        </v-chip>
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12" md="3">
                                <div class="chart-subtitle">Proporção por Cabeça (quantidade de credores)</div>
                                <apexchart
                                    type="donut"
                                    height="350"
                                    :options="meEppCountOptions"
                                    :series="meEppCountSeries"
                                />
                            </v-col>
                            <v-col v-for="currency in currencyOptions" :key="'meEpp-amount-' + currency.key" cols="12" md="3">
                                <div class="chart-subtitle">Proporção por Valor ({{ currency.label }})</div>
                                <apexchart
                                    type="donut"
                                    height="350"
                                    :options="buildAmountOptions('meEpp', currency.key, ['#00796B', '#80CBC4'])"
                                    :series="buildAmountSeries('meEpp', currency.key)"
                                />
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-row v-if="!loading && noData">
            <v-col cols="12">
                <v-alert type="info" text class="mt-4">
                    Nenhuma informação encontrada.
                </v-alert>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import VueApexCharts from 'vue-apexcharts';

Vue.component('apexchart', VueApexCharts);

function createEmptyCurrencies() {
    return {
        brl: { totalCount: 0, totalAmount: 0, adherenceCount: 0, adherenceAmount: 0 },
        usd: { totalCount: 0, totalAmount: 0, adherenceCount: 0, adherenceAmount: 0 },
        eur: { totalCount: 0, totalAmount: 0, adherenceCount: 0, adherenceAmount: 0 },
    };
}

export default {
    name: 'PlanAdherenceCharts',

    data: function () {
        return {
            user: null,
            loading: false,
            generatingPdf: false,
            filters: {
                status: null,
                process_type: null,
            },
            // statusOptions: [
            //     { text: 'Todos', value: null },
            //     { text: 'Pendente', value: 0 },
            //     { text: 'Aprovado', value: 1 },
            //     { text: 'Rejeitado', value: 2 },
            // ],
            // processTypeOptions: [
            //     { text: 'Todos', value: null },
            //     { text: 'Credor', value: 1 },
            //     { text: 'Procurador', value: 2 },
            // ],
            breadcrumbItems: [
                { text: 'Homepage', disabled: false, to: '/home', exact: true },
                { text: 'Adesão ao Plano', disabled: false, to: '/adesao-plano', exact: true },
                { text: 'Gráficos por Classe', disabled: true, exact: true },
            ],
            currencyOptions: [
                { key: 'brl', label: 'BRL', symbol: 'R$' },
                { key: 'usd', label: 'USD', symbol: 'US$' },
                { key: 'eur', label: 'EUR', symbol: '€' },
            ],
            chartData: {
                trabalhista: {
                    totalCount: 0,
                    totalAmount: 0,
                    adherenceCount: 0,
                    adherenceAmount: 0,
                    currencies: createEmptyCurrencies(),
                },
                quirografarios: {
                    totalCount: 0,
                    totalAmount: 0,
                    adherenceCount: 0,
                    adherenceAmount: 0,
                    currencies: createEmptyCurrencies(),
                },
                meEpp: {
                    totalCount: 0,
                    totalAmount: 0,
                    adherenceCount: 0,
                    adherenceAmount: 0,
                    currencies: createEmptyCurrencies(),
                },
            },
        };
    },

    computed: {
        noData: function () {
            return (
                this.chartData.trabalhista.totalCount === 0 &&
                this.chartData.quirografarios.totalCount === 0 &&
                this.chartData.meEpp.totalCount === 0
            );
        },

        // ==========================================
        // TRABALHISTA — Series e Options
        // ==========================================
        trabalhistaCountSeries: function () {
            var adhered = this.chartData.trabalhista.adherenceCount;
            var notAdhered = this.chartData.trabalhista.totalCount - adhered;
            return [adhered, notAdhered < 0 ? 0 : notAdhered];
        },

        trabalhistaCountOptions: function () {
            var total = this.chartData.trabalhista.totalCount;
            var adhered = this.chartData.trabalhista.adherenceCount;
            var notAdhered = total - adhered;
            var pctAd = total > 0 ? ((adhered / total) * 100).toFixed(1) : '0.0';
            var pctNot = total > 0 ? ((notAdhered / total) * 100).toFixed(1) : '0.0';
            return this.buildDonutOptions(
                [
                    'Aderiram (' + pctAd + '%) — ' + adhered.toLocaleString('pt-BR') + ' credores',
                    'Sem manifestação (' + pctNot + '%) — ' + (notAdhered < 0 ? 0 : notAdhered).toLocaleString('pt-BR') + ' credores'
                ],
                ['#7E55AB', '#C4A4D8'],
                false,
                'Cabeça',
                adhered.toLocaleString('pt-BR') + ' de ' + total.toLocaleString('pt-BR')
            );
        },

        trabalhistaAmountSeries: function () {
            var adhered = this.chartData.trabalhista.adherenceAmount;
            var notAdhered = this.chartData.trabalhista.totalAmount - adhered;
            return [adhered, notAdhered < 0 ? 0 : notAdhered];
        },

        trabalhistaAmountOptions: function () {
            var self = this;
            var total = this.chartData.trabalhista.totalAmount;
            var adhered = this.chartData.trabalhista.adherenceAmount;
            var notAdhered = total - adhered;
            var pctAd = total > 0 ? ((adhered / total) * 100).toFixed(1) : '0.0';
            var pctNot = total > 0 ? ((notAdhered / total) * 100).toFixed(1) : '0.0';
            return self.buildDonutOptions(
                [
                    'Aderido (' + pctAd + '%) — R$ ' + self.formatCurrency(adhered),
                    'Sem manifestação (' + pctNot + '%) — R$ ' + self.formatCurrency(notAdhered < 0 ? 0 : notAdhered)
                ],
                ['#7E55AB', '#C4A4D8'],
                true,
                'Valor',
                self.formatCurrencyCenter(adhered)
            );
        },

        // ==========================================
        // QUIROGRAFÁRIOS — Series e Options
        // ==========================================
        quirografariosCountSeries: function () {
            var adhered = this.chartData.quirografarios.adherenceCount;
            var notAdhered = this.chartData.quirografarios.totalCount - adhered;
            return [adhered, notAdhered < 0 ? 0 : notAdhered];
        },

        quirografariosCountOptions: function () {
            var total = this.chartData.quirografarios.totalCount;
            var adhered = this.chartData.quirografarios.adherenceCount;
            var notAdhered = total - adhered;
            var pctAd = total > 0 ? ((adhered / total) * 100).toFixed(1) : '0.0';
            var pctNot = total > 0 ? ((notAdhered / total) * 100).toFixed(1) : '0.0';
            return this.buildDonutOptions(
                [
                    'Aderiram (' + pctAd + '%) — ' + adhered.toLocaleString('pt-BR') + ' credores',
                    'Sem manifestação (' + pctNot + '%) — ' + (notAdhered < 0 ? 0 : notAdhered).toLocaleString('pt-BR') + ' credores'
                ],
                ['#1E88E5', '#90CAF9'],
                false,
                'Cabeça',
                adhered.toLocaleString('pt-BR') + ' de ' + total.toLocaleString('pt-BR')
            );
        },

        quirografariosAmountSeries: function () {
            var adhered = this.chartData.quirografarios.adherenceAmount;
            var notAdhered = this.chartData.quirografarios.totalAmount - adhered;
            return [adhered, notAdhered < 0 ? 0 : notAdhered];
        },

        quirografariosAmountOptions: function () {
            var self = this;
            var total = this.chartData.quirografarios.totalAmount;
            var adhered = this.chartData.quirografarios.adherenceAmount;
            var notAdhered = total - adhered;
            var pctAd = total > 0 ? ((adhered / total) * 100).toFixed(1) : '0.0';
            var pctNot = total > 0 ? ((notAdhered / total) * 100).toFixed(1) : '0.0';
            return self.buildDonutOptions(
                [
                    'Aderido (' + pctAd + '%) — R$ ' + self.formatCurrency(adhered),
                    'Sem manifestação (' + pctNot + '%) — R$ ' + self.formatCurrency(notAdhered < 0 ? 0 : notAdhered)
                ],
                ['#1E88E5', '#90CAF9'],
                true,
                'Valor',
                self.formatCurrencyCenter(adhered)
            );
        },

        // ==========================================
        // ME/EPP — Series e Options
        // ==========================================
        meEppCountSeries: function () {
            var adhered = this.chartData.meEpp.adherenceCount;
            var notAdhered = this.chartData.meEpp.totalCount - adhered;
            return [adhered, notAdhered < 0 ? 0 : notAdhered];
        },

        meEppCountOptions: function () {
            var total = this.chartData.meEpp.totalCount;
            var adhered = this.chartData.meEpp.adherenceCount;
            var notAdhered = total - adhered;
            var pctAd = total > 0 ? ((adhered / total) * 100).toFixed(1) : '0.0';
            var pctNot = total > 0 ? ((notAdhered / total) * 100).toFixed(1) : '0.0';
            return this.buildDonutOptions(
                [
                    'Aderiram (' + pctAd + '%) — ' + adhered.toLocaleString('pt-BR') + ' credores',
                    'Sem manifestação (' + pctNot + '%) — ' + (notAdhered < 0 ? 0 : notAdhered).toLocaleString('pt-BR') + ' credores'
                ],
                ['#00796B', '#80CBC4'],
                false,
                'Cabeça',
                adhered.toLocaleString('pt-BR') + ' de ' + total.toLocaleString('pt-BR')
            );
        },

        meEppAmountSeries: function () {
            var adhered = this.chartData.meEpp.adherenceAmount;
            var notAdhered = this.chartData.meEpp.totalAmount - adhered;
            return [adhered, notAdhered < 0 ? 0 : notAdhered];
        },

        meEppAmountOptions: function () {
            var self = this;
            var total = this.chartData.meEpp.totalAmount;
            var adhered = this.chartData.meEpp.adherenceAmount;
            var notAdhered = total - adhered;
            var pctAd = total > 0 ? ((adhered / total) * 100).toFixed(1) : '0.0';
            var pctNot = total > 0 ? ((notAdhered / total) * 100).toFixed(1) : '0.0';
            return self.buildDonutOptions(
                [
                    'Aderido (' + pctAd + '%) — R$ ' + self.formatCurrency(adhered),
                    'Sem manifestação (' + pctNot + '%) — R$ ' + self.formatCurrency(notAdhered < 0 ? 0 : notAdhered)
                ],
                ['#00796B', '#80CBC4'],
                true,
                'Valor',
                self.formatCurrencyCenter(adhered)
            );
        },
    },

    created: function () {
        this.user = this.$root.user.data || this.$root.user;
        this.loadCharts();
    },

    methods: {
        formatCurrency: function (value) {
            if (!value && value !== 0) return '0,00';
            return Number(value).toLocaleString('pt-BR', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            });
        },

        formatCurrencyCenter: function (value) {
            if (!value && value !== 0) return 'R$ 0,00';
            return 'R$ ' + Number(value).toLocaleString('pt-BR', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            });
        },

        getCurrencyOption: function (currencyKey) {
            return this.currencyOptions.find(function (currency) {
                return currency.key === currencyKey;
            }) || this.currencyOptions[0];
        },

        formatCurrencyWithSymbol: function (value, currencyKey) {
            var currency = this.getCurrencyOption(currencyKey);
            return currency.symbol + ' ' + this.formatCurrency(value);
        },

        formatCurrencyCenterByKey: function (value, currencyKey) {
            return this.formatCurrencyWithSymbol(value, currencyKey);
        },

        buildAmountSeries: function (classKey, currencyKey) {
            var currencyData = this.chartData[classKey].currencies[currencyKey] || {};
            var adhered = currencyData.adherenceAmount || 0;
            var notAdhered = (currencyData.totalAmount || 0) - adhered;
            return [adhered, notAdhered < 0 ? 0 : notAdhered];
        },

        buildAmountOptions: function (classKey, currencyKey, colors) {
            var currencyData = this.chartData[classKey].currencies[currencyKey] || {};
            var total = currencyData.totalAmount || 0;
            var adhered = currencyData.adherenceAmount || 0;
            var notAdhered = total - adhered;
            var pctAd = total > 0 ? ((adhered / total) * 100).toFixed(1) : '0.0';
            var pctNot = total > 0 ? ((notAdhered / total) * 100).toFixed(1) : '0.0';

            return this.buildDonutOptions(
                [
                    'Aderido (' + pctAd + '%) — ' + this.formatCurrencyWithSymbol(adhered, currencyKey),
                    'Sem manifestação (' + pctNot + '%) — ' + this.formatCurrencyWithSymbol(notAdhered < 0 ? 0 : notAdhered, currencyKey)
                ],
                colors,
                true,
                this.getCurrencyOption(currencyKey).label,
                this.formatCurrencyCenterByKey(adhered, currencyKey)
            );
        },

        getValueFontSize: function (text) {
            var len = text.length;
            if (len > 22) return '11px';
            if (len > 18) return '12px';
            if (len > 14) return '13px';
            return '15px';
        },

        buildDonutOptions: function (labels, colors, isCurrency, centerTopText, centerBottomText) {
            var self = this;
            var valueFontSize = isCurrency ? self.getValueFontSize(centerBottomText) : '16px';
            return {
                chart: {
                    type: 'donut',
                    height: 350,
                },
                labels: labels,
                colors: colors,
                plotOptions: {
                    pie: {
                        donut: {
                            size: '62%',
                            labels: {
                                show: true,
                                name: {
                                    show: true,
                                    fontSize: '14px',
                                    fontWeight: 600,
                                    color: '#333333',
                                    offsetY: -8,
                                    formatter: function () {
                                        return centerTopText;
                                    }
                                },
                                value: {
                                    show: true,
                                    fontSize: valueFontSize,
                                    fontWeight: 'bold',
                                    color: '#333333',
                                    offsetY: 6,
                                    formatter: function () {
                                        return centerBottomText;
                                    }
                                },
                                total: {
                                    show: true,
                                    showAlways: true,
                                    label: centerTopText,
                                    color: '#333333',
                                    fontSize: '14px',
                                    fontWeight: 400,
                                    formatter: function () {
                                        return centerBottomText;
                                    }
                                }
                            }
                        }
                    }
                },
                dataLabels: {
                    enabled: true,
                    formatter: function (val) {
                        return val.toFixed(1) + '%';
                    },
                    style: {
                        fontSize: '13px',
                        fontWeight: 'bold',
                        colors: ['#FFFFFF'],
                    },
                    dropShadow: {
                        enabled: true,
                        top: 1,
                        left: 1,
                        blur: 2,
                        color: '#000',
                        opacity: 0.45
                    },
                },
                tooltip: {
                    custom: function (opts) {
                        var seriesIndex = opts.seriesIndex;
                        var w = opts.w;
                        var label = w.config.labels[seriesIndex] || '';
                        var color = w.config.colors[seriesIndex] || '#333';
                        var val = opts.series[seriesIndex];

                        var parts = label.split(' — ');
                        var title = parts[0];
                        var detail = parts.length > 1 ? parts[1] : '';

                        if (isCurrency && !detail) {
                            detail = self.formatCurrency(val);
                        } else if (!detail) {
                            detail = val.toLocaleString('pt-BR') + ' credores';
                        }

                        return '<div style="background:#FFFFFF; border:1px solid #E0E0E0; border-radius:6px; padding:10px 14px; font-size:13px; box-shadow:0 2px 8px rgba(0,0,0,0.15);">' +
                            '<div style="display:flex; align-items:center; margin-bottom:6px;">' +
                                '<span style="display:inline-block;width:12px;height:12px;border-radius:3px;background:' + color + ';margin-right:8px;flex-shrink:0;"></span>' +
                                '<span style="font-weight:700; color:#212121; font-size:13px;">' + title + '</span>' +
                            '</div>' +
                            '<div style="margin-left:20px; font-weight:600; color:#212121; font-size:13px;">' + detail + '</div>' +
                        '</div>';
                    },
                },
                legend: {
                    position: 'bottom',
                    floating: false,
                    fontSize: '12px',
                    fontWeight: 500,
                    horizontalAlign: 'center',
                    labels: {
                        colors: ['#333333'],
                    },
                    markers: {
                        width: 12,
                        height: 12,
                        radius: 3,
                        offsetX: -4,
                    },
                    itemMargin: {
                        vertical: 8,
                        horizontal: 8,
                    },
                    formatter: function (seriesName) {
                        var parts = seriesName.split(' — ');
                        if (parts.length === 2) {
                            return '<span style="font-weight:600;color:#333333;">' + parts[0] + '</span><br/><span style="font-size:12px;font-weight:500;color:#333333;">' + parts[1] + '</span>';
                        }
                        return seriesName;
                    },
                },
                states: {
                    hover: {
                        filter: {
                            type: 'darken',
                            value: 0.15,
                        }
                    }
                },
                stroke: {
                    width: 2,
                    colors: ['#fff'],
                },
                noData: {
                    text: 'Nenhum dado disponível',
                    align: 'center',
                    verticalAlign: 'middle',
                },
            };
        },

        loadCharts: async function () {
            var self = this;
            self.loading = true;

            var params = {};

            if (self.filters.status !== null && self.filters.status !== undefined) {
                params.status = self.filters.status;
            }
            if (self.filters.process_type !== null && self.filters.process_type !== undefined) {
                params.process_type = self.filters.process_type;
            }

            await axios.get('/api/admin/plan-adherence/user-creditors-charts', { params: params })
                .then(function (result) {
                    var data = result.data.content;
                    self.processChartData(data);
                })
                .catch(function (error) {
                    self.$dialog.notify.error(self.$codes(error), {
                        position: 'top-right',
                        timeout: 5000,
                    });
                })
                .finally(function () {
                    self.loading = false;
                });
        },

        processChartData: function (data) {
            // Classe I - Trabalhista
            var trabalhista = (data && data.trabalhista) || {};
            this.chartData.trabalhista.totalCount = trabalhista.total_count || 0;
            this.chartData.trabalhista.totalAmount = trabalhista.total_amount || 0;
            this.chartData.trabalhista.adherenceCount = trabalhista.adherence_count || 0;
            this.chartData.trabalhista.adherenceAmount = trabalhista.adherence_amount || 0;
            this.chartData.trabalhista.currencies = this.normalizeCurrencyData(trabalhista.currencies);

            // Classe III - Quirografários
            var quirografarios = (data && data.quirografarios) || {};
            this.chartData.quirografarios.totalCount = quirografarios.total_count || 0;
            this.chartData.quirografarios.totalAmount = quirografarios.total_amount || 0;
            this.chartData.quirografarios.adherenceCount = quirografarios.adherence_count || 0;
            this.chartData.quirografarios.adherenceAmount = quirografarios.adherence_amount || 0;
            this.chartData.quirografarios.currencies = this.normalizeCurrencyData(quirografarios.currencies);

            // Classe IV - ME/EPP
            var meEpp = (data && data.me_epp) || {};
            this.chartData.meEpp.totalCount = meEpp.total_count || 0;
            this.chartData.meEpp.totalAmount = meEpp.total_amount || 0;
            this.chartData.meEpp.adherenceCount = meEpp.adherence_count || 0;
            this.chartData.meEpp.adherenceAmount = meEpp.adherence_amount || 0;
            this.chartData.meEpp.currencies = this.normalizeCurrencyData(meEpp.currencies);
        },

        normalizeCurrencyData: function (currencies) {
            var normalized = createEmptyCurrencies();
            var source = currencies || {};

            this.currencyOptions.forEach(function (currency) {
                var item = source[currency.key] || {};

                normalized[currency.key] = {
                    totalCount: item.total_count || item.totalCount || 0,
                    totalAmount: item.total_amount || item.totalAmount || 0,
                    adherenceCount: item.adherence_count || item.adherenceCount || 0,
                    adherenceAmount: item.adherence_amount || item.adherenceAmount || 0,
                };
            });

            return normalized;
        },

        async generateVotingPdf() {

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja gerar o laudo das adesões em PDF?',
                title: 'Gerar laudo em PDF',
                actions: {
                    false: 'Cancelar',
                    true: 'Gerar'
                }
            })

            if (!proceedAction) return;

            try {
                this.generatingPdf = true;

                const response = await axios.post(
                    '/api/admin/plan-adherence/voting-report-pdf',
                    {},
                    {
                        responseType: 'blob',
                    }
                );

                const blob = new Blob([response.data], { type: 'application/pdf' });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = 'laudo_adesoes.pdf';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);

                this.$dialog.notify.info("Arquivo PDF gerado com sucesso!",
                    {
                        position: "top-right",
                        timeout: 2000
                    }
                );

            } catch (error) {
                console.log('Erro ao gerar PDF:', error);
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 5000,
                });
            } finally {
                this.generatingPdf = false;
            }
        },

    },
};
</script>

<style lang="scss">
.apexcharts-legend-text {
    opacity: 1 !important;
    color: #333333 !important;
}

.apexcharts-legend-series {
    opacity: 1 !important;
}
</style>

<style lang="scss" scoped>
.card-group-title {
    flex-wrap: wrap;
    gap: 8px 0;
}

.chart-subtitle {
    font-size: 13px;
    font-weight: 500;
    color: #757575;
    text-align: center;
    margin-bottom: 4px;
}

.chart-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
}
</style>
